
export default function ({ store }) {
  if (!store.getters['auth/isAuthenticated']) {
    return this.router.push('/account/login')
  }
}
